import {Pipe, PipeTransform} from '@angular/core';
import {PermissionsService} from '../service/permissions.service';

@Pipe({
    name: 'disabledByPermissions',
    pure: false,
    standalone: true
})
export class NlrPermissionsDisabledPipe implements PipeTransform {
    constructor(private permissionsService: PermissionsService) {}

    transform(names: string[]): boolean {
        return this.permissionsService.isDisabledByPermissions(names);
    }
}
